import HeroSection from "../components/HeroSection";
import AboutCTA from "./AboutUs/AboutCTA";
import AboutUsSnapshot from "./AboutUsSnapshot";
import BlogSection from "./BlogSection";
import CertificationsSection from "./CertificationsSection";
import CompanyWithOurCompany from "./CompanyWithOurCompany";
import CoreProductCategories from "./CoreProductCategories";
import FactoryCapabilities from "./FactoryCapabilities";
import FeaturedProjects from "./FeaturedProjects";
import IndustriesWeServe from "./IndustriesWeServe";
import QuickContact from "./QuickContact";
import TestimonialsSlider from "./TestimonialsSlider";
import WhyChooseUs from "./WhyChooseSection";
import Seo from "./../components/Seo";

const Home = () => {
  return (
    <div>
      <Seo
        title="Burj Al Yarmouk Industries LLC – Metal Fabrication, Storage Tanks, Generator Enclosures in UAE"
        description="Burj Al Yarmouk Industries L.L.C specializes in custom metal fabrication, diesel storage tanks, generator acoustic enclosures, skid frames, STP tanks, structural works, and engineering solutions across the UAE. Trusted by industries for high-quality fabrication and durable engineering products."
        url="https://burjalyarmouk.com/"
        image="https://burjalyarmouk.com/og-banner.jpg"
        keywords="
    metal fabrication uae,
    fabrication company abu dhabi,
    storage tank fabrication uae,
    generator acoustic enclosures uae,
    diesel tank supplier uae,
    skid frame manufacturing,
    steel fabrication workshop abu dhabi,
    custom engineering solutions uae,
    sheet metal fabrication,
    industrial fabrication company uae
  "
      />

      <HeroSection id="home" />
      <AboutUsSnapshot id="about" />
      <CoreProductCategories />
      <WhyChooseUs id="why" />
      <IndustriesWeServe />
      {/* <FeaturedProjects /> */}
      <FactoryCapabilities />
      {/* <CertificationsSection /> */}
      {/* <TestimonialsSlider /> */}
      {/* <BlogSection /> */}
      <QuickContact />
      <CompanyWithOurCompany />
      <AboutCTA />
    </div>
  );
};

export default Home;
